import * as React from 'react';

import { compose } from 'recompose';

import Retracked from 'js/app/retracked';
import { isAuthenticatedUser } from 'js/lib/user';

import AuthenticationModal from 'bundles/authentication/shared/components/authentication-modal/AuthenticationModal';
import { getShouldShowUnregisteredOnboarding } from 'bundles/coursera-plus/utils/subscriptionsForwardDiscoveryExperiment';
import withMarketingConsent from 'bundles/user-consent/components/withMarketingConsent';

import 'css!../__styles__/index';

type Props = {
  children?: React.ReactNode;
};

const Onboarding2022App = ({ children }: Props) => {
  const shouldShowUnregisteredOnboarding = getShouldShowUnregisteredOnboarding();
  if (!isAuthenticatedUser() && !shouldShowUnregisteredOnboarding) {
    return <AuthenticationModal utilizeWebRedirectOnClose onCloseRedirectURL="/" />;
  } else {
    return <div className="rc-Onboarding2022App">{children}</div>;
  }
};

export default compose<{}, React.PropsWithChildren<{}>>(
  Retracked.createTrackedContainer(() => {
    return {
      namespace: {
        app: 'onboarding_2022',
        page: 'onboarding_2022',
      },
    };
  }),
  withMarketingConsent
)(Onboarding2022App);
